import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const DownloadIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M13.032 8v4.667H3.699V8H2.365v4.667c0 .733.6 1.333 1.334 1.333h9.333c.733 0 1.333-.6 1.333-1.333V8h-1.333Zm-4 .447 1.727-1.72.94.94L8.365 11 5.032 7.667l.94-.94 1.727 1.72V2h1.333v6.447Z" />
  </Icon>
);

export default memo(DownloadIcon);
